<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3> {{get_dialogMain.title}} </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
            <DepartmentForm :model="user" :on-success="saveUser" :on-cancel="cancel" />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DepartmentForm from '@/components/forms/DepartmentForm'
export default {
  props: ['model'],
  data: () => ({
    user: {}
  }),
  components: {
    DepartmentForm
  },
  mounted () {
    if (this.model.id) {
      this.user = Object.assign({}, this.model)
    }
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlPostServicesAction']),
    saveUser (model) {
      const router = this.get_urls['empresa.departamento-store']
      this.urlPostServicesAction({ url: router, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_OBJECT', 'SET_DATA_OBJECT'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitos!',
        text: 'Se agrego correctamente el registro'
      })
      this.SET_DATA_OBJECT(val)
      this.CLEAR_OBJECT()
      this.cancel()
    }
  }
}
</script>

<style>

</style>
